import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { NEWSLETTER } from "@/constants/testIds";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return toast.error("Inserisci la tua email.");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/newsletter`, { email });
      toast.success(data.message);
      setEmail("");
    } catch {
      toast.error("Email non valida. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#1f2937] text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 pb-28 lg:pb-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2 max-w-sm">
            <div className="flex items-center gap-2">
              <img src="/logo-icon.png" alt="PeakStudy" className="h-10 w-10 object-contain bg-white rounded-lg p-1" />
              <span className="font-heading text-xl font-extrabold">
                <span className="text-[#5982c5]">Peak</span><span className="text-[#f0d203]">Study</span>
              </span>
            </div>
            <p className="mt-4 text-white/60 leading-relaxed">
              Your next level starts here. Strumenti pratici per studiare con più controllo e capire davvero ciò che leggi.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-4">Naviga</h4>
            <ul className="space-y-2 text-white/60">
              <li><button onClick={() => scrollTo("manuale")} className="hover:text-[#f0d203] transition-colors">Il Manuale</button></li>
              <li><button onClick={() => scrollTo("benefici")} className="hover:text-[#f0d203] transition-colors">Benefici</button></li>
              <li><button onClick={() => scrollTo("recensioni")} className="hover:text-[#f0d203] transition-colors">Recensioni</button></li>
              <li><button onClick={() => scrollTo("faq")} className="hover:text-[#f0d203] transition-colors">FAQ</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold mb-4">Newsletter</h4>
            <p className="text-white/60 text-sm mb-4">Consigli di studio gratuiti, ogni tanto. Niente spam.</p>
            <form data-testid={NEWSLETTER.form} onSubmit={subscribe} className="flex gap-2">
              <input
                data-testid={NEWSLETTER.email}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="La tua email"
                className="flex-1 min-w-0 px-4 py-2.5 rounded-full bg-white/10 border border-white/15 text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-[#5982c5] text-sm"
              />
              <button
                data-testid={NEWSLETTER.submit}
                type="submit"
                disabled={loading}
                className="shrink-0 bg-[#f0d203] text-[#1a1a1a] hover:bg-[#dcb902] transition-colors font-bold w-11 h-11 rounded-full flex items-center justify-center disabled:opacity-70"
                aria-label="Iscriviti"
              >
                {loading ? <Loader2 size={18} className="animate-spin" /> : <Send size={18} />}
              </button>
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-white/50">
          <p>© {new Date().getFullYear()} PeakStudy. Tutti i diritti riservati.</p>
          <div className="flex gap-6">
            <button className="hover:text-white transition-colors">Privacy Policy</button>
            <button className="hover:text-white transition-colors">Termini di Servizio</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
